import api from "../../../lib/axios";

const BASE_URL = "/Project";

export const projectService = {
  getAll: async (params) => {
    const response = await api.get(`${BASE_URL}`, { params });
    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await api.get(`${BASE_URL}/search`, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
  edit: async (id) => {
    const response = await api.get(`${BASE_URL}/edit/${id}`);
    return response.data;
  },

  create: async (formData) => {
    const response = await api.post(`${BASE_URL}`, formData);
    return response.data;
  },

  update: async (id, formData) => {
    const response = await api.put(`${BASE_URL}/${id}`, formData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  changePublishStatus: async (id, isPublished) => {
    const response = await api.put(`${BASE_URL}/change-publish-status/${id}`, { isPublished });
    return response.data;
  },

  reorder: async (items) => {
    const response = await api.put(`${BASE_URL}/reorder`, items);
    return response.data;
  },

  uploadImage: async (projectId, formData) => {
    const response = await api.post(`${BASE_URL}/${projectId}/images`, formData);
    return response.data;
  },

  deleteImage: async (projectId, imageId) => {
    const response = await api.delete(`${BASE_URL}/${projectId}/images/${imageId}`);
    return response.data;
  },

  reorderImages: async (projectId, items) => {
    const response = await api.put(`${BASE_URL}/${projectId}/images/reorder`, items);
    return response.data;
  },
};
